import {
    RVColumn,
    RVHelpPopup,
    RVHelpPopupPresetButton,
    RVHelpPopupTextareaForm,
    RVHelpPopupWelcome,
} from "@regal-voice/ui";

import styles from "./JourneyCopilotHelper.module.scss";

const LABEL = "Ask Copilot about this Journey!";

const PRESET_PROMPTS = ["Explain how this Journey works.", "What are the diffs between the latest versions?"];

type JourneyCopilotHelperProps = {
    onNavigate: (prompt: string) => void;
};

export function JourneyCopilotHelper({ onNavigate }: JourneyCopilotHelperProps): JSX.Element {
    return (
        <RVHelpPopup
            icon="loading-3-quarters"
            label={LABEL}
            anchorSide="right"
            anchorVertical="bottom"
            className={styles.helpPopup}
            width={320}
        >
            <RVHelpPopupWelcome icon="loading-3-quarters" header="Regal Copilot" />

            <RVColumn gap={2} padding={2} className={styles.bottomSection}>
                {PRESET_PROMPTS.map((prompt) => (
                    <RVHelpPopupPresetButton key={prompt} label={prompt} onClick={() => onNavigate(prompt)} />
                ))}
                <RVHelpPopupTextareaForm onSubmit={onNavigate} />
            </RVColumn>
        </RVHelpPopup>
    );
}
